<template>
  <div>
    <table class="table table-hover">
    <tbody v-if="site.integrations && site.integrations.hosting && site.integrations.hosting.ip">
    <tr>
      <td>Account</td>
      <td>{{ site.hosting.name }}</td>
    </tr>
    <tr v-if="site.integrations.hosting.ip.ip_address">
      <td>IP</td>
      <td>
        {{ site.integrations.hosting.ip.ip_address }}
      </td>
    </tr>
    <tr v-if="site.integrations.hosting.ip.city">
      <td>Location</td>
      <td>
        {{ site.integrations.hosting.ip.city }}, {{ site.integrations.hosting.ip.country }}
        <i :class="'pull-right flag-icon flag-icon-' + (site.integrations.hosting.ip.country_code.toLowerCase() )"></i>
      </td>
    </tr>
    <tr>
      <td>Server Signature</td>
      <td v-if="site.integrations.hosting.ip && site.integrations.hosting.ip.signature">
        {{ site.integrations.hosting.ip.signature.signature }}
      </td>
    </tr>
    <tr v-if="site.integrations.hosting.health">
      <td>Resolved</td>
      <td>
            <span
              :class="site.integrations.hosting.ip.ip_address === site.integrations.hosting.health.resolved_ip_address ? 'green' : 'red'"
            >
              {{ site.integrations.hosting.health.resolved_ip_address || '/' }}
            </span>
        <span
          v-if="user.admin && site.registrar && site.registrar.integration && site.registrar.integration.canUpdateRecords &&
              site.integrations.hosting.ip.ip_address !== site.integrations.hosting.health.resolved_ip_address">
              <a v-if="!site.customData.dnsUpdate || $moment(site.customData.dnsUpdate.date).format('X') < $moment().format('X') - 72000"><i class="fa fa-upload pull-right" title="Update DNS Records" @click="updateNsRecord(site.integrations.hosting.ip.ip_address)"></i></a>
              <span v-else><i class="fa fa-clock orange pull-right" :title="'Dns update has been requested ' + $moment(site.customData.dnsUpdate.date).from()"></i></span>
            </span>
      </td>
    </tr>
    <tr v-if="site.integrations.hosting.health && site.integrations.hosting.ip.ip_address !== site.integrations.hosting.health.resolved_www_ip_address">
      <td>Resolved WWW</td>
      <td>
            <span
              :class="site.integrations.hosting.ip.ip_address === site.integrations.hosting.health.resolved_www_ip_address ? 'green' : 'red'"
            >
              {{ site.integrations.hosting.health.resolved_www_ip_address || '/' }}
            </span>
      </td>
    </tr>
    <tr v-if="site.integrations.hosting.software">
      <td>Software</td>
      <td>
        <i class="fa fa-wordpress pull-right"></i>
        <i class="fa fa-check green" v-if="site.integrations.hosting.software.status === 'ACTIVE'"></i>
        <i class="fa fa-clock orange" v-if="site.integrations.hosting.software.status === 'PENDING'"></i>
        {{ site.integrations.hosting.software.software_name }}
      </td>
    </tr>
    <tr>
      <td>SSL</td>
      <td v-if="site.integrations && site.integrations.hosting.ssl">
        <i class="fa fa-check green" v-if="site.integrations.hosting.ssl.status === 'ACTIVE'"></i>
        <i class="fa fa-clock orange" v-if="site.integrations.hosting.ssl.status === 'PENDING'"></i>
        {{ site.integrations.hosting.ssl.certificate_type }}
      </td>
      <td v-else>
        <button class="btn btn-primary btn-xs" v-if="!sslInstalling" @click="installSSL"><i class="fa fa-lock"></i> Install SSL</button>
        <span v-else>Installing...</span>
      </td>
    </tr>
    <tr>
      <td>Hosting</td>
      <td>
        <span v-if="hostingUpdating">Updating...</span>
        <span v-else>
              <span v-if="site.integrations && site.integrations.hosting.hostingType !== 'CUSTOM_HOST'">
                <v-select :options="site.hosting.data.hosts" label="name" index="guid" :value="site.hosting.hosting" @input="updateHosting"></v-select>
              </span>
              <span v-else>
                <a-edit-txt
                  :options="site.hosting.data.hosts"
                  type="select"
                  select-value="guid" select-label="name"
                  :locked="!user.admin"
                  :text="site.integrations.hosting.hostingName"
                  close-on-save="true"
                  @input="updateHosting"
                ></a-edit-txt>
              </span>
            </span>
      </td>
    </tr>
    <tr>
      <td>Network:</td>
      <td v-if="site.integrations.hosting.network">
        {{ site.integrations.hosting.network }}
      </td>
    </tr>
    <tr>
      <td>Deploy</td>
      <td>
        <span
          v-if="(site.integrations && site.integrations.hosting.hostingType === 'CUSTOM_HOST') ||
          (site.integrations.hosting && site.integrations.hosting.software && site.integrations.hosting.software.status === 'ACTIVE')"
        >
          <button
            v-if="site.staging && site.staging.domain"
            class="btn btn-xs btn-success"
            @click="deployProd(1)"
          ><i class="fa fa-refresh"></i> Deploy Staging</button>
        </span>
      </td>
    </tr>
    </tbody>
    <tbody v-if="!site.integrations || !site.integrations.hosting || !site.integrations.hosting.ip">
      <tr>
        <td colspan="2">
          <v-select :options="freeIps" label="ip" index="id" v-model="assignedIp" placeholder="Select IP address">
            <template v-slot:option="option">
              <i :class="'flag-icon flag-icon-' + option.data.country_code.toLowerCase()"></i> {{ option.ip }} ({{ option.used }}/{{ option.slots }})
            </template>
          </v-select>
          <v-select :options="site.hosting.data.hosts" label="name" index="guid"  placeholder="Select Hosting" class="m-t-sm" v-model="assignedHosting"></v-select>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <button class="btn btn-xs btn-primary" @click="assignIp" :disabled="!assignedIp || !assignedHosting">Assign</button>
          <!--            <button class="btn btn-xs btn-default pull-right" @click="assignIp(true)">Assign First</button>-->
          <span class="pull-right ">
              <input class="" type="checkbox" v-model="uniqueIpsOnly" @change="getFreeIps(1, (!uniqueIpsOnly) + 0)"> Only Unique
            </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'
import { PBN_SET } from '../../../../../../../store/mutation-types'

export default {
  data () {
    return {
      hostingUpdating: false,
      uniqueIpsOnly: true,
      sslInstalling: false,
      wpInstalling: false,
      deployToDedicated: 1,
      assignedIp: null,
      assignedHosting: null,
      freeIps: []
    }
  },
  props: ['site', 'user'],
  watch: {
    site () {
      this.sslInstalling = false
    }
  },
  mounted () {
    if (this.site.hosting && !this.freeIps.length) {
      this.getFreeIps()
    }
  },
  methods: {
    deployProd (rebuild = 0, backup = 0) {
      axios.post(`/pbn/site/${this.site.punyDomain}/deploy?rebuild=${rebuild}&backup=${backup}`)
        .then(r => {
          this.$toastr.success('Deploy process has been started', 'Ok')
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error('Not good I guess', 'No')
        })
    },
    getFreeIps (free = 1, allowDuplicates = 0) {
      axios.get(`/hosting/${this.site.hosting.id}/ips?free=${free}&client=${this.site.client.id}&allowDuplicates=${allowDuplicates}`)
        .then(r => {
          this.freeIps = r.data.data
        })
        .catch()
    },
    assignIp () {
      axios.post(`/pbn/site/${this.site.punyDomain}/hosting/assign-ip`, {
        ip: this.assignedIp,
        hosting: this.assignedHosting
      })
        .then(r => {
          this.$toastr.success('Ip assigned')
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error('Error', e)
        })
    },
    installSSL () {
      axios.post(`/pbn/site/${this.site.punyDomain}/hosting/install-ssl`)
        .then(r => {
          this.sslInstalling = true
          this.$toastr.success('SSL Queued for Install', 'If everything goes to plan it should be up in a couple of minutes')
        })
        .catch()
    },
    installWP () {
      axios.post(`/pbn/site/${this.site.punyDomain}/hosting/install-wp`)
        .then(r => {
          this.wpInstalling = true
          this.$toastr.success('WP Queued for Install', 'If everything goes to plan it should be up in a couple of minutes')
        })
        .catch()
    },
    updateNsRecord (ip) {
      axios.patch(`/pbn/site/${this.site.punyDomain}/registrar/record`, {
        'type': 'A',
        'subdomain': '@',
        'record': ip
      })
        .then(r => {
          this.$toastr.success('The request has been sent. It could take a while before it propagates', 'NS Record Update Sent')
        }).catch()
    },
    updateHosting (guid) {
      axios.patch(`/pbn/site/${this.site.punyDomain}/hosting/host`, {
        hosting: guid
      })
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
          this.hostingUpdating = true
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Build/Hosts/PriorityProspect.vue